import { baseApi, API_TAGS } from '@/shared/api';
import {
  MappingLocationsResponse,
  MappingDataResponse,
  MappingCorridorsResponse,
  MappingBreakdownResponse,
  createDashboardEndpointBuilder
} from '@/entities/dashboard';

const mappingEndpoint = createDashboardEndpointBuilder('/mapping');

export const mappingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMappingLocations: builder.query<MappingLocationsResponse, void>({
      query: () => ({
        url: mappingEndpoint('/locations')
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    }),

    getMappingStock: builder.query<MappingDataResponse, { weekNo?: number } | undefined>({
      query: (params) => ({
        url: mappingEndpoint('/stock'),
        params
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    }),

    getMappingCorridors: builder.query<MappingCorridorsResponse, { type?: 'RIT' | 'RIH' } | undefined>({
      query: (params = { type: 'RIT' }) => ({
        url: mappingEndpoint('/corridors'),
        params
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    }),

    getMappingReleases: builder.query<MappingDataResponse, void>({
      query: () => ({
        url: mappingEndpoint('/releases')
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    }),

    getMappingRequests: builder.query<MappingDataResponse, { type?: 'RIC' | 'RPU' } | undefined>({
      query: (params = { type: 'RIC' }) => ({
        url: mappingEndpoint('/requests'),
        params
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    }),

    getMappingBreakdown: builder.query<MappingBreakdownResponse, { locationId: string; type?: 'REO' | 'REP' }>({
      query: ({ locationId, type = 'REO' }) => ({
        url: mappingEndpoint('/breakdown'),
        params: { locationId, type }
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.MAPPING]
    })
  })
});

export const {
  useGetMappingLocationsQuery,
  useGetMappingStockQuery,
  useGetMappingCorridorsQuery,
  useGetMappingReleasesQuery,
  useGetMappingRequestsQuery,
  useGetMappingBreakdownQuery
} = mappingApi;
